{
  "name": "wisegolf",
  "version": "2.19.3",
  "versionDate": "28.05.2026",
  "private": true,
  "scripts": {
    "dev": "vite",
    "serve": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint .",
    "reset_project": "rm -rf ./node_modules && yarn",
    "push-dev": "gsutil -m cp -a public-read -r ./dist/. gs://static_html/webapps/wisegolfdev",
    "push-prod": "gsutil -m cp -a public-read -r ./dist/. gs://static_html/webapps/wisegolf",
    "invcache-dev": "gcloud compute url-maps invalidate-cdn-cache prod-1-lb-1 --host devapp.wisegolf.fi --path /webapps/wisegolfdev/index.html --project wiseframetest --async",
    "invcache-prod": "gcloud compute url-maps invalidate-cdn-cache prod-1-lb-1 --host app.wisegolf.fi --path /webapps/wisegolf/index.html --project wiseframetest --async"
  },
  "dependencies": {
    "@awesome-cordova-plugins/core": "^8.1.0",
    "@awesome-cordova-plugins/diagnostic": "^8.1.0",
    "@capacitor-community/fcm": "^8.1.0",
    "@capacitor/android": "^8.0.2",
    "@capacitor/app": "^8.0.0",
    "@capacitor/app-launcher": "^8.0.0",
    "@capacitor/browser": "^8.0.0",
    "@capacitor/clipboard": "^8.0.0",
    "@capacitor/core": "^8.0.2",
    "@capacitor/device": "^8.0.0",
    "@capacitor/filesystem": "^8.0.0",
    "@capacitor/geolocation": "^8.0.0",
    "@capacitor/haptics": "^8.0.0",
    "@capacitor/ios": "^8.0.2",
    "@capacitor/keyboard": "^8.0.0",
    "@capacitor/network": "^8.0.0",
    "@capacitor/preferences": "^8.0.0",
    "@capacitor/push-notifications": "^8.0.0",
    "@capacitor/splash-screen": "^8.0.0",
    "@capacitor/status-bar": "^8.0.0",
    "@capawesome/capacitor-android-edge-to-edge-support": "^8.0.5",
    "@ionic-native/core": "^5.36.0",
    "@ionic-native/ibeacon": "^5.36.0",
    "@ionic/vue": "^8.0.0",
    "@ionic/vue-router": "^8.0.0",
    "cordova.plugins.diagnostic": "^7.1.4",
    "@popperjs/core": "^2.11.5",
    "@sentry/capacitor": "3.2.1",
    "@sentry/vite-plugin": "^5.2.1",
    "@sentry/vue": "10.43.0",
    "axios": "1.15.0",
    "capacitor-native-settings": "^8.0.0",
    "choices.js": "^10.2.0",
    "date-fns": "^2.28.0",
    "ionicons": "^7.0.0",
    "moment": "^2.30.1",
    "rxjs": "^7.8.2",
    "swiper": "^8.2.2",
    "v-calendar": "3.0.1",
    "vue": "^3.5.6",
    "vue-i18n": "^9.9.1",
    "vue-json-pretty": "^2.1.0",
    "vue-router": "^4.4.5",
    "vuex": "^4.0.2"
  },
  "devDependencies": {
    "@capacitor/cli": "8.0.2",
    "@vitejs/plugin-legacy": "^8.0.0",
    "@vitejs/plugin-vue": "^6.0.0",
    "eslint": "^8.35.0",
    "eslint-plugin-vue": "^9.9.0",
    "terser": "^5.4.0",
    "vite": "^8.0.0"
  },
  "description": "WiseGolf"
}
